import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import { DjayAvatar, useDjaySelection } from '../../mascot';
import { humanizeFamilyId } from '../../content';
import { getEnabledModes } from '../../modes';
import { tapSpring, hoverLift } from '../../components/shared/motionPresets';
import { soundManager } from '../../utils/soundManager';
import { hapticManager } from '../../utils/hapticManager';
import { getMasteryLabelInfo } from './masteryLabelInfo';
interface ContinueStripProps {
  modeId: string;
  familyId?: string;
  score?: number;
  timestamp: number;
  onContinue: () => void;
}
export function ContinueStrip({
  modeId,
  familyId,
  score,
  timestamp,
  onContinue
}: ContinueStripProps) {
  const {
    selectedVariant
  } = useDjaySelection();
  const mode = getEnabledModes().find(m => m.id === modeId);
  if (!mode) return null;
  const handleClick = () => {
    soundManager.playClick();
    hapticManager.hapticLight();
    onContinue();
  };
  return <motion.button onClick={handleClick} {...tapSpring} {...hoverLift} className="w-full bg-white rounded-2xl p-3 sm:p-4 shadow-sm border border-slate-200 flex items-center gap-4 group text-left" data-id="element-3168" data-mp="1n58bngn003e6">
      
      <div className="flex-shrink-0 w-10 h-10 bg-slate-50 rounded-full flex items-center justify-center border border-slate-100" data-id="element-3169" data-mp="1df6p4taamt1d">
        <DjayAvatar size="sm" emotion="encouraging" variant={selectedVariant} animate={false} data-id="element-3170" data-mp="19ap6wyjl0nsp" />
        
      </div>

      <div className="flex-1 min-w-0" data-id="element-3171" data-mp="213yb32xaif5p">
        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-3172" data-mp="2150zn47545ig">
          Verder waar je was
        </div>
        <div className="text-sm font-bold text-slate-800 truncate" data-id="element-3173" data-mp="1x4h3o3yaz7xw">
          {mode.title}
          {familyId && <span className="text-slate-500 font-medium" data-id="element-3174" data-mp="1s5dx2f2octnt">
              {' '}
              — {humanizeFamilyId(familyId)}
            </span>}
        </div>
        {/* Hier stond "Vorige score: 62%" — een ruw percentage zonder label, op
             de strip die een kind uitnodigt verder te gaan. Juist dáár is een
             getal schadelijk: het is het laatste wat het kind leest voordat het
             opnieuw begint, en een matig cijfer op die plek ontmoedigt in plaats
             van uit te nodigen. Het label uit masteryLabelInfo.ts zegt hetzelfde
             zonder cijfer. */}
        {score !== undefined && <div className="text-xs text-slate-500 mt-0.5" data-id="element-3175" data-mp="3vk6frb99fnwb">
            Vorige keer:{' '}
            <span className="font-bold text-slate-700" data-id="element-3176" data-mp="3vid7xsmwuxmq">
              {getMasteryLabelInfo(score).label}
            </span>
          </div>}
      </div>

      <div className="flex-shrink-0 flex items-center gap-2 text-indigo-600" data-id="element-3177" data-mp="3ln1pp0can8a8">
        <span className="text-xs font-bold hidden sm:inline-block" data-id="element-3178" data-mp="3qkk4h7czshq5">
          Doorgaan
        </span>
        <div className="w-8 h-8 rounded-full bg-indigo-50 flex items-center justify-center group-hover:bg-indigo-100 transition-colors" data-id="element-3179" data-mp="3cksk8ovvu53p">
          <ArrowRight className="w-4 h-4" data-id="element-3180" data-mp="3hjvqgcnlmhd9" />
        </div>
      </div>
    </motion.button>;
}